import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import Tooltip from 'components/shared/Tooltip';
import LocationEpisode from 'models/LocationEpisode';
import colors from 'styles/theme/colors';

type Props = {
  locationEpisode: LocationEpisode;
};

export default function PatientClassifications({ locationEpisode }: Props) {
  return (
    <ChipContainer data-cy='planAndEpisodeLabels'>
      {!!locationEpisode.planTypeClassification?.name && (
        <>
          <HoverableChip
            textValue={`Plan Type: ${locationEpisode.planTypeClassification.name}`}
            styles={{ backgroundColor: '#E7F5FB', color: '#085272' }}
          />
        </>
      )}
      {locationEpisode.episodeClassifications.map((ec) => (
        <HoverableChip
          key={ec.id}
          textValue={`Episode Type: ${ec.name}`}
          styles={{ backgroundColor: colors.black05, color: colors.black75 }}
        />
      ))}
    </ChipContainer>
  );
}

const HoverableChip = ({
  textValue,
  styles,
}: {
  textValue: string;
  styles: { backgroundColor: string; color: string };
}) => {
  const [renderTooltip, setRenderTooltip] = useState(false);
  const chipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (chipRef.current) {
      const rect = chipRef.current.getBoundingClientRect();
      setRenderTooltip(rect.width >= 240);
    }
  }, [chipRef]);

  return (
    <Tooltip text={textValue} position='bottom' disabled={!renderTooltip}>
      <Chip ref={chipRef} backgroundColor={styles.backgroundColor} color={styles.color}>
        {textValue}
      </Chip>
    </Tooltip>
  );
};

const ChipContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
  margin-top: 8px;
`;

const Chip = styled.div<{ backgroundColor?: string; color?: string }>`
  background-color: ${(props) => props.backgroundColor || '#E7F5FB'};
  color: ${(props) => props.color || '#085272'};
  border-radius: 3px;
  padding: 8px;
  font-size: 12px;
  font-weight: bold;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: default;
`;
